import { Ic_rayo } from "../../helpers/ImagesCache"; //Iconos especificos cargados en cache por el desarrolador

const TimelineShoks = ({ data, startTime, endTime, icon }) => {
  const totalDuration = endTime - startTime;

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{ width: "100%", height: 1, backgroundColor: "#888586" }}
      ></div>
      {/* Dots for each shock */}
      {data?.map((item, index) => {
        const leftPercent =
          (((item.stop ?? item.start ?? item.time) - startTime) /
            totalDuration) *
          100;

        return (
          <div
            key={index}
            style={{
              position: "absolute",
              top: "50%",
              transform: "translate(-50%, -50%)",
              left: `${leftPercent}%`,
              width: "24px",
              height: "24px",
            }}
            title={`Start: ${item.start}`}
          >
            <img src={icon ?? Ic_rayo}></img>
          </div>
        );
      })}
    </div>
  );
};

export default TimelineShoks;
